import Vector from "victor";
import { isInIframe } from "@/wbcontroller/util";
import { FolderNavigationMap, WhiteboardData } from "./stateInterfaceType";
import { ModalType } from "./ModalType";
import WhiteboardServerData from "@/WhiteboardServerData";
import WhiteboardConfig from "@/WhiteboardConfig";

export function jsonToWhiteboardData(
  data: WhiteboardServerData
): WhiteboardData {
  return {
    wbid: data.wbid,
    name: data.name,
    isTemplate: data.is_template,
    constantSize: data.constant_size
      ? new Vector(data.constant_size.width, data.constant_size.height)
      : null,
    backgroundImageURL: data.bg_image_url,
    datetimeExpire: data.t_expire,
  };
}
export function getInitialUsername(config?: WhiteboardConfig): string {
  if (config && config.user) {
    return config.user.display_name || localStorage.guestUsername || "";
  } else {
    return localStorage.guestUsername || "";
  }
}
export function getInitialModals(config: WhiteboardConfig): Set<ModalType> {
  if (config.whiteboard.wbid === "demo") {
    return new Set([ModalType.DemoNote]);
  } else if (!getInitialUsername(config) && !isInIframe()) {
    return new Set([ModalType.GuestUsername]);
  } else if (config.session.is_newly_claimed) {
    return new Set([ModalType.Claimed]);
  } else {
    return new Set([]);
  }
}

export function getFolderNavigationMap(
  config: WhiteboardConfig
): FolderNavigationMap {
  const NEXT_MAP = new Map<string, string | null>();
  const PREVIOUS_MAP = new Map<string, string | null>();
  const INDEX_MAP = new Map<string, number>();
  if (config.folder) {
    let last: string | null = null;
    let i = 0;
    for (const child of config.folder.whiteboards) {
      i += 1;
      INDEX_MAP.set(child.wbid, i);
      PREVIOUS_MAP.set(child.wbid, last);
      if (last) {
        NEXT_MAP.set(last, child.wbid);
      }
      last = child.wbid;
    }
    if (last) {
      NEXT_MAP.set(last, null);
    }
  }
  return {
    next: NEXT_MAP,
    previous: PREVIOUS_MAP,
    index: INDEX_MAP,
  };
}
